export default __webpack_public_path__ + "static/media/pediasure850.2de9404a.jpg";